import { render } from "./AllegroAccountHeader.vue?vue&type=template&id=73b6956a&scoped=true"
import script from "./AllegroAccountHeader.vue?vue&type=script&lang=js"
export * from "./AllegroAccountHeader.vue?vue&type=script&lang=js"

import "./AllegroAccountHeader.vue?vue&type=style&index=0&id=73b6956a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b6956a"]])

export default __exports__